import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport } from "vue";
import { ref } from 'vue';
export default {
  __name: 'PreviewImages',
  setup(__props, {
    expose: __expose
  }) {
    const visible = ref(false);
    const imageList = ref([]);
    const currentIndex = ref(0);
    function open(images, defaultIndex = 0) {
      visible.value = true;
      imageList.value = images;
      currentIndex.value = defaultIndex;
    }
    function close() {
      visible.value = false;
    }
    __expose({
      open,
      close
    });
    return (_ctx, _cache) => {
      const _component_el_image_viewer = _resolveComponent("el-image-viewer");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [visible.value ? (_openBlock(), _createBlock(_component_el_image_viewer, {
        key: 0,
        "url-list": imageList.value,
        "initial-index": currentIndex.value,
        "show-progress": "",
        class: "fixed inset-0",
        onClose: _cache[0] || (_cache[0] = $event => visible.value = false)
      }, null, 8, ["url-list", "initial-index"])) : _createCommentVNode("", true)]);
    };
  }
};